<template>
    <v-card flat>
        <v-card-title>
            <Button
                    width="248"
                    depressed
                    v-on:onClick="openCreateWebsite"
                    class="my-3"
                    content="+ ADD WEBSITE"
            />
            <v-spacer></v-spacer>
            <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
            ></v-text-field>
        </v-card-title>
        <v-data-table
                class="custom-table custom-table__header"
                :headers="headers"
                :items="websitesData"
                :loading="loading"
                :items-per-page="itemsPerPage"
                :page.sync="page"
                @update:sort-desc="handleSortDesc"
                @update:sort-by="handleSortBy"
                hide-default-footer
        >
            <template v-slot:item.clients="{ item }">
                <div> {{ displayClientList(item.clients)}}</div>
            </template>
            <template v-slot:item.categories="{ item }">
                <div> {{ displayCategoriesList(item.categories)}}</div>
            </template>
            <template v-slot:item.sp_available="{ item }">
                <div> {{ displaySPAvailable(item)}}</div>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon
                        small
                        class="mr-2"
                        @click="openEditItem(item)"
                        title="Edit website"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                        small
                        @click="openDeleteItem(item)"
                        title="Delete website"
                >
                    mdi-delete
                </v-icon>
            </template>
            <template v-slot:no-data> NO DATA </template>
        </v-data-table>
        <v-row class="align-center">
            <v-col cols="12" sm="11" >
                <v-pagination
                        v-model="page"
                        :length="pageCount"
                        :total-visible="7"
                        @input="onChangePagination"
                ></v-pagination>
            </v-col>
            <v-col cols="12" sm="1">
                <v-select
                        :value="10"
                        :items="[5, 10, 15, 25, 50]"
                        label="Items per page"
                        @change="handleItemsPerPage"
                        hint="Items per page"
                        persistent-hint
                ></v-select>
            </v-col>
        </v-row>
        <v-dialog v-model="dialogCreate" max-width="500px" persistent>
            <v-card>
                <v-form
                        ref="create"
                        v-model="valid"
                        lazy-validation
                >
                    <v-card-title class="headline scan-header">{{ formTitle }}</v-card-title>
                    <v-card-text>
                        <v-container class="py-0">
                            <v-row>
                                <v-col cols="12" class="py-0">
                                    <v-text-field
                                            v-model="newWebsite.display_name"
                                            label="Name"
                                            :rules="[v => !!(v && Object.keys(v).length !== 0) || 'This field is required']"
                                            required
                                    ></v-text-field>
                                    <v-text-field
                                            v-model="newWebsite.url"
                                            label="URL"
                                            :rules="[v => !!(v && Object.keys(v).length !== 0) || 'This field is required']"
                                            required
                                            hint="example https://www.example.com"
                                            persistent-hint
                                    ></v-text-field>
                                    <v-autocomplete
                                            v-model="newWebsite.clients"
                                            item-value="id"
                                            item-text="name"
                                            :items="getClientsSimple"
                                            placeholder="Clients"
                                            required
                                            dense
                                            :rules="[autocompleteRule]"
                                            @change="handleSelectClient"
                                            hint="Select client first"
                                            persistent-hint
                                            multiple
                                            :search-input.sync="searchClient"
                                    ></v-autocomplete>
                                    <v-autocomplete
                                            v-model="newWebsite.categories"
                                            item-value="id"
                                            item-text="name"
                                            :items="getCategoriesSimple"
                                            placeholder="Categories"
                                            dense
                                            @change="handleSelectCategories"
                                            persistent-hint
                                            multiple
                                            :search-input.sync="searchCategory"
                                    ></v-autocomplete>
                                    <v-checkbox
                                            class="my-0"
                                            v-model="isSourcepoint"
                                            label="Sourcepoint"
                                            @change="handleCheckSourcepoint"
                                            :disabled="newWebsite.clients[0] === sourcepointClientId || !newWebsite.clients[0]"
                                    ></v-checkbox>
                                    <v-combobox
                                            v-model="newWebsite.publisher"
                                            :items="publisherList"
                                            :search-input.sync="searchPublisher"
                                            hide-selected
                                            placeholder="Publisher"
                                            dense
                                            v-if="false"
                                    >
                                        <template v-slot:no-data>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        No results matching "<strong>{{ searchPublisher }}</strong>". Press <kbd>enter</kbd> to create a new one
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-combobox>
<!--                                    <v-text-field-->
<!--                                            type="number"-->
<!--                                            max="2147483647"-->
<!--                                            min="0"-->
<!--                                            v-model="newWebsite.sp_account_id"-->
<!--                                            label="Sourcepoint Account ID"-->
<!--                                            @change="handleChangeNumber('sp_account_id')"-->
<!--                                            :rules="[numberRuleSpAccountId]"-->
<!--                                            required-->
<!--                                            disabled-->
<!--                                    ></v-text-field>-->
                                    <v-text-field
                                            type="number"
                                            max="2147483647"
                                            min="0"
                                            v-model="newWebsite.sp_site_id"
                                            label="Sourcepoint Property ID"
                                            @change="handleChangeNumber('sp_site_id')"
                                            :rules="[numberRuleSpSiteId]"
                                            required
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-container class="py-0">
                            <v-row>
                                <v-col cols="12" align="right">
                                    <v-btn color="red darken-1" text @click="closeCreate">Cancel</v-btn>
                                    <v-btn color="green darken-1" text @click="save">Save</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px" persistent>
            <v-card>
                <v-form
                        ref="delete"
                        v-model="deleteValid"
                        lazy-validation
                >
                    <v-card-title class="headline scan-header">Confirm delete website</v-card-title>
                    <v-card-text>
                        <div>Please, enter 'Delete {{websiteName}}' in the text field to confirm website deletion</div>
                        <v-text-field
                                v-model="confirmDelete"
                                label="Delete Website"
                                :rules="[deleteRule]"
                                single-line
                        ></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                        <v-btn color="blue darken-1" text @click="deleteWebsite">OK</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
    import Button from "../common/Button";
    import { createNamespacedHelpers } from "vuex";
    const adminDashboardHelper = createNamespacedHelpers("adminDashboard");
    import adminDashboardApi from '../../api/adminDashboard'
    export default {
        components: {Button},
        name: 'WebsitesDashboard',
        computed:{
            ...adminDashboardHelper.mapGetters(["getWebsitesList", "getPublishers", "getClientsSimple", "getCategoriesSimple"]),
            formTitle () {
                return this.editedIndex === -1 ? 'CREATE WEBSITE' : 'EDIT WEBSITE'
            },
        },
        data () {
            return {
                search: '',
                searchClient: null,
                searchCategory: null,
                searchPublisher: null,
                headers: [
                    { text: 'Id', align: 'start', value: 'id', sortable: false  },
                    { text: 'Name', value: 'display_name' },
                    { text: 'URL', value: 'url' },
                    { text: 'Clients', value: 'clients', sortable: false },
                    { text: 'Categories', value: 'categories', sortable: false },
                    { text: 'Available in Sourcepoint Account', value: 'sp_available', sortable: false },
                    // { text: 'Sourcepoint Account ID', value: 'sp_account_id', sortable: false },
                    { text: 'Sourcepoint Property ID', value: 'sp_site_id', sortable: false },
                    { text: 'Actions', value: 'actions', sortable: false },
                ],
                websitesData: [],
                dialogCreate: false,
                dialogDelete: false,
                loading: true,
                page: 1,
                pageCount: 1,
                itemsPerPage: 10,
                totalCount: 1,
                sortDesc: true,
                sort_field: "display_name",
                newWebsite: {
                    display_name: '',
                    url: '',
                    clients: [],
                    categories: [],
                    publisher: null,
                    // sp_account_id: null,
                    sp_site_id: null,
                },
                websiteId: '',
                websiteName: '',
                editedIndex: -1,
                numberRuleSpAccountId: v  => {
                    if (!isNaN(parseFloat(v)) && v < 0 && v !== null){
                        return 'Number has to be more or equal 0';
                    }
                    // else if (this.newWebsite.sp_site_id !== null && v === null){
                    //     return 'Invalid values combination for fields sp_account_id and sp_site_id. Values can either be both None or both valid integers';
                    // }
                    return true;
                },
                numberRuleSpSiteId: v  => {
                    if (!isNaN(parseFloat(v)) && v < 0 && v !== null){
                        return 'Number has to be more or equal 0';
                    }
                    // else if (this.newWebsite.sp_account_id !== null && v === null){
                    //     return 'Invalid values combination for fields sp_account_id and sp_site_id. Values can either be both None or both valid integers';
                    // }
                    return true;
                },
                autocompleteRule: v =>{
                    if (v && Object.keys(v).length !== 0) return true;
                    return 'This field is required';
                },
                deleteRule: v =>{
                    if (!(v && Object.keys(v).length !== 0)) {
                        return 'This field is required';
                    } else if(!(v && this.confirmDelete.includes(`Delete ${this.websiteName}`))){
                        return 'The confirmation message must meet the requirements';
                    } return true;
                },
                confirmDelete: '',
                valid: true,
                deleteValid: true,
                publisherList: [],
                isSourcepoint: false,
                sourcepointClientId: '7e5a26ee-dc6b-443f-988b-baf30e501d36'
            }
        },
        methods: {
            ...adminDashboardHelper.mapActions([ "fetchWebsitesList", "fetchPublishers", "fetchClientsSimple", "fetchCategoriesSimple"]),
            async getPublishersData(){
                await this.fetchPublishers();
            },
            async getClientsSimpleData(){
                await this.fetchClientsSimple();
            },
            async getCategoriesData(){
                await this.fetchCategoriesSimple();
            },
            async getWebsitesDashboard(){
                this.loading = true;
                await this.fetchWebsitesList({
                    page: this.page,
                    page_size: this.itemsPerPage < 0 ? this.pageCount : this.itemsPerPage,
                    sort: this.sortDesc ? 1 : 0,
                    s: this.search,
                    sort_field: this.sort_field ? this.sort_field : 'display_name'
                });
                this.loading = false;
            },
            openCreateWebsite(){
                this.editedIndex = -1;
                this.dialogCreate = true;
            },
            closeCreate () {
                this.dialogCreate = false;
                this.newWebsite = {
                    display_name: '',
                    url: '',
                    clients: [],
                    categories: [],
                    publisher: null,
                    // sp_account_id: null,
                    sp_site_id: null,
                };
                this.isSourcepoint = false;
                this.$refs.create.resetValidation();
            },
            async save(){
                if(this.$refs.create.validate()){
                    if(this.editedIndex > -1){
                        try{
                            await adminDashboardApi.editWebsite(this.websiteId, this.newWebsite);
                            this.closeCreate();
                            this.getWebsitesDashboard();
                        }catch(err){
                            alert(err.response ? (err.response.status === 422 ? err.response.data.detail[0].msg : err.response.data.detail ) : err)
                        }
                    } else {
                        try{
                            await adminDashboardApi.createWebsite(this.newWebsite);
                            this.closeCreate();
                            this.getWebsitesDashboard();
                        }catch(err){
                            alert(err.response ? (err.response.status === 422 ? err.response.data.detail[0].msg : err.response.data ) : err)
                        }
                    }
                }

            },
            openDeleteItem(website){
                this.websiteId = website.id;
                this.websiteName = website.display_name;
                this.dialogDelete = true
            },
            closeDelete(){
                this.dialogDelete = false;
                this.confirmDelete = '';
                this.$refs.delete.resetValidation();
            },
            async deleteWebsite(){
                if(this.$refs.delete.validate()){
                    if(this.confirmDelete.includes(`Delete ${this.websiteName}`)){
                        try{
                            await adminDashboardApi.deleteWebsite(this.websiteId);
                            this.closeDelete();
                            this.getWebsitesDashboard();
                        }catch(err){
                            alert(err)
                        }
                    }
                }
            },
            openEditItem(website){
                this.websiteId = website.id;
                this.editedIndex = this.websitesData.indexOf(website);
                let clients = [];
                website.clients.forEach(c=>{
                    if(c.id === this.sourcepointClientId) {
                        clients.push(c.id);
                    } else {
                        clients.unshift(c.id);
                    }
                    if(website.clients.length > 1 && c.id === this.sourcepointClientId){
                        this.isSourcepoint = true
                    }
                });
                this.newWebsite = Object.assign({},
                    {display_name: website.display_name},
                    {url: website.url},
                    {clients: clients},
                    {categories: website.categories ? website.categories.map(c => c.id) : []},
                    {publisher: website.publisher},
                    // {sp_account_id: website.sp_account_id ? website.sp_account_id : null },
                    {sp_site_id: website.sp_site_id},
                );
                this.dialogCreate = true;
            },
            handleItemsPerPage(itemsPerPage){
                this.page = 1;
                this.itemsPerPage = itemsPerPage;
                this.getWebsitesDashboard();
            },
            handleSortDesc(desc){
                if( this.sortDesc !== desc[0] && desc.length){
                    this.sortDesc = desc[0];
                    this.getWebsitesDashboard();
                }
            },
            handleSortBy(sortBy){
                if(this.sort_field !== sortBy[0] && sortBy.length){
                    this.sort_field = sortBy[0];
                    this.getWebsitesDashboard();
                }
            },
            handleChangeNumber(field){
                if(this.newWebsite[field] !== ''){
                    this.newWebsite[field] = Number(this.newWebsite[field]);
                } else {
                    this.newWebsite[field] = null
                }
                this.$refs.create.validate()
            },
            onChangePagination(){
                this.getWebsitesDashboard();
            },
            displayClientList(clients){
                return clients.map(client => client.name).join("; ");
            },
            displayCategoriesList(categories){
               return categories && categories.length ? categories.map(c => c.name).join("; ") : '';
            },
            displaySPAvailable(website){
                // return website.sp_account_id && website.sp_site_id ? 'Yes': 'No'
                return website.sp_site_id ? 'Yes': 'No'
            },
            handleSelectClient(e){
                this.newWebsite.clients = e;
                e.forEach(client=>{
                    if(client === this.sourcepointClientId){
                        this.isSourcepoint = false;
                    }
                });
                let publisherNameList = [];
                this.getClientsSimple.map(c => {
                    e.forEach(clId=>{
                        if(c.id === clId){
                            publisherNameList.push(c.name)
                        }
                    });
                });
                this.newWebsite.publisher = publisherNameList.join(", ");
                this.searchClient = '';
            },
            handleSelectCategories(e){
                this.newWebsite.categories = e;
                this.searchCategory = '';
            },
            handleCheckSourcepoint(e){
                if(e){
                    this.newWebsite.clients.push(this.sourcepointClientId)
                } else {
                    this.newWebsite.clients.forEach((c,i)=>{
                        c === this.sourcepointClientId && this.newWebsite.clients.splice(i, 1)
                    })
                }
            }
        },
        created () {
            this.getWebsitesDashboard();
            this.getPublishersData();
            this.getClientsSimpleData();
            this.getCategoriesData();
        },
        watch: {
            getWebsitesList: function(e){
                this.websitesData = e.results;
                this.pageCount = Math.ceil(e.count/this.itemsPerPage);
                this.totalCount = e.count;
            },
            search: function(){
                this.page = 1;
                this.getWebsitesDashboard();
            },
            getPublishers: function(publishers){
                publishers.forEach(p=>{
                    if( p !== null){
                        this.publisherList.push(p);
                    } else {
                        this.publisherList.push("No publisher")
                    }
                })

            },
        }
    }
</script>
